export type Mapping<T> = {
  [key: string]: T;
};
